import xrmApiAnonymous from "src/services/xrmApi"

import { Category } from "src/states/shop/category"

export const fetchCategories = async (): Promise<Category[]> =>
  xrmApiAnonymous
    .get(
      `/Category?exhibitionId=${process.env.NEXT_PUBLIC_WEBSHOP_XRM_EVENT_ID}`,
    )
    .then((res) => res?.data ?? [])
